<input type="text" [(ngModel)]="searchText" (change)="changedSearchText()" />
